export function getMmcInstance(publicKey: string) {
  return window.DeviceFingerprint?.mmc({
    env: 'same_domain',
    publicKey: publicKey,
  })
}
